import React, { FC, ReactNode } from 'react'

interface PriceAvailabilityMessageProps {
  text: ReactNode
}

const PriceAvailabilityMessage: FC<PriceAvailabilityMessageProps> = ({
  text,
}) => {
  return <span className="lh-copy b f3 c-danger">{text}</span>
}

export default PriceAvailabilityMessage
